<div class="text-center" style="z-index: 10000;" *ngIf="currentUser">

  <div style="max-width:350px; z-index:10000;" class="mx-auto">

    <div class="form-group">
      <label for="telephone" class="menu-box-text">Nr telefonu komórkowego</label>
      <input type="text"
             [(ngModel)]="currentUser.TFATelephone"
             class="form-control"
             [mask]="phoneMask"
             [ngClass]="{ 'is-invalid': submittedCodeRequest && isTFATelephoneValidationError }" />
      <div *ngIf="submittedCodeRequest" class="alert-danger">
        <div *ngIf="isTFATelephoneValidationError && currentUser.TFATelephone">Podany numer telefonu komórkowego jest niepoprawny.</div>
        <div *ngIf="!currentUser.TFATelephone">Numer telefonu komórkowego jest wymagany.</div>
      </div>



      <button style="margin-bottom: 20px; margin-top: 20px;" [disabled]="codeRequestProcessing" class="btn btn-primary form-control" (click)="onTelSubmit()">
        <span *ngIf="codeRequestProcessing" class="spinner-border spinner-border-sm mr-1"></span>
        Wyślij SMS z kodem weryfikacyjnym
      </button>
    </div>

    <div *ngIf="codeSend" class="alert-info mb-4">
      <div class="p-1">
        <p>Kod weryfikacyjny wysłany na nr telefonu {{currentUser.TFATelephone}}.</p>
        <p>Kod jest ważny przez 10 minut.</p>
      </div>
    </div>


    <div class="form-group" *ngIf="IsCodeVerificationAvailable()">

      <label for="tfaCode" class="menu-box-text">Kod weryfikacyjny z wiadomości SMS</label>
      <input type="text" [(ngModel)]="currentUser.TFACode" class="form-control" />

      <div class="margin-t-10"></div>

      <button style="margin-bottom: 20px;" [disabled]="codeVeryficationProcessing || !currentUser.TFACode" class="btn btn-primary form-control" (click)="onCodeSubmit()">
        <span *ngIf="codeVeryficationProcessing" class="spinner-border spinner-border-sm mr-1"></span>
        Weryfikacja kodu
      </button>

    </div>

    <div *ngIf="IsCodeVerificationRequestError()" class="alert-danger">
      <div class="p-1">{{codeVerificationRequestError}}</div>
    </div>

  </div>
</div>
